export default __webpack_public_path__ + "static/media/wcF.0c98815f.png";